{
  "en": {
    "ticket": {
      "actions": {
        "assignCustomer": "Complete procedure",
        "bulk_assign_new_emp": "Bulk assign new responsible",
        "close": "Close",
        "create_new": "Create new conversation",
        "customer_new_ticket": "New conversation",
        "delete": "Delete",
        "edit": "Edit",
        "goToConversation": "Go to conversation",
        "move_to_existing": "Move message to existing conversation",
        "new": "Conversation",
        "reopen": "Reopen",
        "selectResponsible": "Select responsible",
        "selectUnit": "Select Unit",
        "show": "Show",
        "startNew": "Start a new conversation"
      },
      "attributes": {
        "status": "Status",
        "statuses": {
          "closed": "Closed",
          "feedback": "Awaiting feedback",
          "ongoing": "Ongoing",
          "open": "Open"
        },
        "title": "Title"
      },
      "editor": {
        "tooltips": {
          "bold": "Bold",
          "bulletList": "Bullet list",
          "highlight": "Highlight",
          "italic": "Italic",
          "link": "Link",
          "orderedList": "Numbered list",
          "redo": "Redo",
          "strike": "Strikethrough",
          "textColor": "Text Color",
          "underline": "Underline",
          "undo": "Undo",
          "unlink": "Unlink"
        }
      },
      "labels": {
        "additionalQuestion": "Do you have any additional question?",
        "all": "All",
        "allProjects": "All projects",
        "allUnits": "All units",
        "assign_conversations": "Assign conversations from",
        "bulk_assign_new_emp_warning": "This update will also include conversations linked to decisions or aftercare. For related decisions (of these affected conversations), the responsible employee will also be updated.",
        "cantChangeResponsibleAftercare": "This conversation is linked to an aftercare ticket. Please change the responsible there.",
        "cantChangeResponsibleDecision": "This conversation is linked to a decision. Please change the responsible there.",
        "cantDelete": "This conversation belongs to a decision and can't be deleted.",
        "cantEdit": "This conversation belongs to a decision. Edit it from the decision instead",
        "changeResponsible": "Modify",
        "change_responsible": "Change responsible of conversations",
        "clientWillRespondSoon": "We will get back to you as soon as possible",
        "contact": "Contact",
        "contactPerson": "Your contact person",
        "contactPersonWithName": "Your {name} contact",
        "conversation_title": "Conversation title",
        "conversations": "Conversations",
        "create_ticket": "Create conversation",
        "customer": "Customer",
        "customers": "Customers",
        "decision": "Which decision?",
        "decisionConversation": "Decision",
        "decisionConversations": "Decisions",
        "disabled_unit": "This unit has been deactivated. No messages can be sent.",
        "documentAddedBy": "from",
        "documents": "Documents",
        "email_forwarding": "Email forwarding",
        "employee": "Employee",
        "export_conversation": "Export conversation",
        "files": "Files",
        "filter": "Filter",
        "inbound_by": "Inbound by {name}",
        "inbound_emails": "Inbound emails",
        "info": "A question and you didn't find your answer in the {faq_route} section? Ask it here! Please try to bundle your questions into clear conversation topics, e.g. 'Specifications'. ",
        "keywords": "Search content",
        "lastMessage": "Last message",
        "message": "Message",
        "message_placeholder": "Write your message here...",
        "message_subtitle": "Describe your question or issue",
        "messaged_at_nulls_first_asc": "Atividade mais antiga",
        "messaged_at_nulls_last_desc": "Última atividade",
        "myProjects": "My projects",
        "myTickets": "My conversations",
        "name_lower_asc": "Título A -> Z",
        "name_lower_desc": "Título Z -> A",
        "newConversation": "New Conversation",
        "newMessage": "New Message",
        "newMessages": "New messages",
        "newWithPartner": "Ziggu and {partner}",
        "newWithZiggu": "Only Ziggu",
        "noCustomer": "No customer assigned or invited yet",
        "noCustomerAssignedToUnit": "No customer assigned to this unit. Would you like to continue?",
        "noCustomerAssignedToUnitExplainer": "Note, you will therefore have to select another recipient.",
        "noCustomerAssignedToUnit_SUP": "No customer assigned to this project. Would you like to continue?",
        "noCustomerInvited": "The customer assigned to this unit has not been invited yet. Would you like to continue?",
        "noFiles": "No files uploaded yet",
        "noMessagesYet": "No messages yet",
        "noTickets": "No conversations",
        "no_messages": "Conversation has no messages",
        "notSeenYet": "Not seen yet",
        "notYetDetermined": "Not yet determined",
        "note": "Note",
        "note_placeholder": "Write only to team members. Type {'@'} to mention a team member and they will be notified.",
        "onlySelect": "Only show",
        "orNewTicket": "Or, open a new one about a different topic",
        "otherTickets": "Other customer conversations",
        "participants": "1 participant | {count} participants",
        "partner": "Partner",
        "partnerGroup": "With whom do you want to talk?",
        "partnersDecision": "Decision partners",
        "pendingContactPerson": "Your contact person will respond as soon as possible",
        "pendingTickets": "New messages",
        "project": "Project",
        "read": "Read",
        "remove_inbound_email": "Remove {email}?",
        "reply": "Reply",
        "reply_placeholder": "Write to everyone",
        "responsible": "Responsible",
        "search": "Search",
        "search_conversation": "Search",
        "seen": "Seen",
        "seenAll": "all",
        "seenBy": "Seen by {name}",
        "selectLevel": "Select level",
        "selectUnit": "Select unit",
        "show": "Showing",
        "showFiles": "Show files",
        "showTicketsFor": "Show conversations for",
        "showingAll": "All conversations",
        "sort": "Sort by",
        "startConversation": "Start a new conversation",
        "startConversationForProject": "Start a new conversation in project ",
        "startNewConversation": "Start a new conversation",
        "subject": "Subject",
        "subject_subtitle": "Describe in a couple of words",
        "teamMember": "Team member",
        "ticketClosed": "This conversation has been closed.",
        "ticketClosedByResponsible": "This conversation has been closed by {responsible}",
        "ticketClosedCustomer": "If you have a different question, please open a new conversation.",
        "ticketClosedEmployee": "If you would like to re-open the conversation, change the status above.",
        "ticket_category": "Category",
        "tickets_all_projects": "Conversations all projects",
        "to": "to",
        "unit": "Unit",
        "unit_name_lower_asc": "Unidade A -> Z",
        "unit_name_lower_desc": "Unidade Z -> A",
        "unread": "Unread",
        "upload_files": "1 file pending | {count} files pending",
        "warning_move_message_to_new_ticket": "This message will be moved to a regular conversation, which will not be linked to a decision or issue.",
        "withMentions": "Mentioned in",
        "withMessages": "With messages",
        "writeMessageToBecomeResponsible": "Write a message to become responsible",
        "you": "You"
      },
      "messages": {
        "redirect_decision": "This conversation is part of a decision. Click here to view the decision.",
        "redirect_issue": "This conversation is part of Aftercare. Click here to go to Aftercare.",
        "redirect_link": "Ver detalhes"
      },
      "navigation": {
        "backToTickets": "Go back"
      },
      "placeholders": {
        "customers": {
          "new": {
            "subtitle": "Try to bundle your questions in general conversation topics, e.g. 'Specifications'.",
            "title": "A question? Ask it here!"
          },
          "none": {
            "title": "No conversations found"
          }
        },
        "employees": {
          "new": {
            "subtitle": "Start your first conversation with someone!",
            "title": "Something to ask?"
          },
          "none": {
            "subtitle": "Adjust the filters on the top of the page or start following a project to find the related conversations",
            "subtitle_aftercare": "Click on the 3 dots of a snag to start a conversation",
            "title": "No conversations found"
          }
        }
      },
      "toasts": {
        "responsible_updated": "Responsible successfully updated!"
      },
      "validation": {
        "mustBeMaximum": "Subject must remain under {number} characters.",
        "needCustomer": "Select a customer",
        "needMessage": "Message required",
        "needName": "Título necessário",
        "needResponsible": "Select a responsible",
        "needSubject": "Subject required",
        "needUnit": "Select a unit"
      }
    }
  }
}